import { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router";
import { useLogout } from "../../Services/Api";

const Header = () => {
  const navigate = useNavigate();
  const [token, setToken] = useState()
  const [userName, setUserName] = useState()
  const [companyName, setCompanyName] = useState()
  const [isChief, setIsChief] = useState()

  const { subpath } = useParams();

  const [data, err, logout, reset] = useLogout()

  useEffect(() => {
    //при смене адреса в строке переспрашиваем локалсторадж об имени 
    //пользователя токена компаниии и т.д.
    setToken(localStorage.getItem('token'));
    setUserName(localStorage.getItem('userName'));
    setCompanyName(localStorage.getItem('companyName'));
    setIsChief(localStorage.getItem('isChief'));
  }, [subpath])

  useEffect(() => {
    if (data?.result) {
      localStorage.removeItem('token')
      localStorage.removeItem('userName')
      localStorage.removeItem('companyName')
      localStorage.removeItem('isChief')
      navigate('/login')
    }
  }, [data])

  useEffect(() => {
    setTimeout(() => {
      reset()
    }, 5000)
  }, [err])

  const logoutHandleClick = () => {
    logout(token);
  }

  return (
    <div className="header">
      <div className="logo"></div>
      <div className="user">
        {!token ? null : (
          <div className="links">
            {subpath === undefined ? (<span>Сканирование</span>) : (<Link
              to="/"
              title="Переход в режим сканирования наклеенных этикеток ЧЗ">
              Сканирование
            </Link>
            )}
            {subpath === 'find' ? (<span>Поиск</span>) : (<Link
              to="/find"
              title="Переход в режим поиска товара по части названия или 1с коду или коду аргегации">
              Поиск
            </Link>
            )}
            {isChief ? (
              <>
                {subpath === 'report' ? (<span>Отчеты</span>) : (<Link
                  to="/report"
                  title="Получение отчетов">
                  Отчеты
                </Link>
                )}
                {subpath === 'replace' ? (<span>Замена</span>) : (<Link
                  to="/replace"
                  title="Замена ошибочных кодов агрегации на новые">
                  Замена
                </Link>
                )}
                {subpath === 'remark' ? (<span>Отметка ошибочных</span>) : (<Link
                  to="/remark"
                  title="Пометить агрегат как ошибочный для последующей перемаркировки">
                  Отметка ошибочных
                </Link>
                )}

              </>
            ) : null

            }

            {/* <Link
              to={subpath === "find" ? "/" : "find"}
              title={subpath === "find" ?
                "Переход в режим сканирования наклеенных этикеток ЧЗ" :
                "Переход в режим поиска товара по части названия или 1с коду"}>
              {subpath === "find" ? "Сканирование" : "Поиск"}
            </Link> */}
          </div>
        )}
        <div className="info">
          <h2>{userName}</h2>
          <h5>{companyName}</h5>
        </div>
        <div className="actions">
          <input type="Button" disabled={!token} value="Выход" onClick={logoutHandleClick} />
          <div className="error">{err}</div>
        </div>
      </div>
    </div>
  )
}

export default Header;